import Swiper from 'swiper';

export default function carouselCsr() {

    $('.swiper-container:not(".gallery-img, .gallery-thumbs, .vehicle-image, .vehicle-thumbs, [data-slider-testimonials], [data-widget-homeslider-slider]")').each(function(index, element) {

        let $this = $(this),
            $carousel = $this.parents('.carousel-wrap').find('.swiper-slide');

        $this.addClass('instance-' + index);
        $this.parents('.carousel-wrap').find('.swiper-next-btn').addClass('swiper-next-btn-' + index);
        $this.parents('.carousel-wrap').find('.swiper-prev-btn').addClass('swiper-prev-btn-' + index);

        if ($(this).hasClass('csr-carousel')) {
            let mySwiper = new Swiper('.instance-' + index, {
                speed: 500,
                slidesPerView: 2,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.swiper-next-btn-' + index,
                    prevEl: '.swiper-prev-btn-' + index
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar',
                },
                breakpoints: {
                    1023: {
                        slidesPerView: 'auto',
                    },
                    767: {
                        slidesPerView: 'auto',
                        slidesOffsetAfter: 45,
                        slidesOffsetBefore: 45,
                    },
                    599: {
                        slidesPerView: 'auto',
                        slidesOffsetAfter: 20,
                        slidesOffsetBefore: 20,
                    },
                }

            });

            let $slides = $('.swiper-slide', $(this));

            if ($slides.length <= 2) {
                $(this).toggleClass('_has-single-slide');
            }
        }
    });
}